import { officialChecks } from "@/mocks/home";

export default function OfficialPortal() {
  return (
    <section id="official" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="text-xs md:text-sm font-label tracking-widest text-accent-400 uppercase">
              Official Portal
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-background-50">
              官方网址入口与真伪辨识
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-50/70">
              围绕「八戒影院官网入口」和「官方网址」，最容易踩的坑不是找不到，而是找错了。
              仿冒页面往往在视觉上做得很像，却夹带弹窗、跳转和诱导下载。下面四条核对方法可以帮助你提高判断的准确度。
            </p>

            <div className="mt-8 space-y-4">
              {officialChecks.map((check) => (
                <div key={check.title} className="flex gap-4">
                  <span className="flex-none w-10 h-10 rounded-md bg-background-50/10 border border-background-50/15 text-accent-400 flex items-center justify-center">
                    <i className={`${check.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h4 className="text-sm md:text-base font-medium text-background-50">
                      {check.title}
                    </h4>
                    <p className="mt-1 text-xs md:text-sm leading-relaxed text-background-50/65">
                      {check.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg overflow-hidden border border-background-50/15">
            <img
              src="https://readdy.ai/api/search-image?query=Conceptual%20image%20of%20a%20magnifying%20glass%20over%20a%20glowing%20grid%20globe%20on%20a%20dark%20warm%20background%2C%20cybersecurity%20and%20verification%20concept%2C%20amber%20and%20deep%20red%20tones%2C%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=bajie-verify-01&orientation=landscape"
              alt="核对官方入口与辨识仿冒页面的概念示意图"
              title="八戒影院官网入口 官方网址 真伪辨识"
              className="w-full h-72 md:h-[420px] object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}